export const fieldType = {
  roleName: 'roleName', // 角色名称
  server: 'server', // 伺服器
  regTime: 'regTime', // 注册时间
  device: 'device', // 常用机型
  order: 'order', // 充值订单 [充值时间、充值订单号、订单截图、充值金额]
  address: 'address', // 常驻地址
  upload: 'upload', // 上传
  account: 'account', // 账号
  accountType: 'accountType', // 账号类型
  customer: 'customer' // 自定义
};

export const formType = {
  input: 'input', // 输入框
  switch: 'switch', // 布尔值，开关
  select: 'select', // 下拉框
  date: 'date', // 日期
  upload: 'upload' // 上传(视频、图片)
};

export const timeFormatType = {
  year: 'yyyy', // vant不支持, 通过隐藏其他列来实现
  'year-month': 'yyyy-MM',
  date: 'yyyy-MM-dd',
  datehour: 'yyyy-MM-dd hh',
  datetime: 'yyyy-MM-dd hh:mm',
  time: 'hh:mm',
  'month-day': 'MM-dd'
};

// 模版分类
export const workTempType = {
  account: 1, // 平台
  guest: 2, // 游客
  store: 3, // 储值
  abnormal: 4 // 异常
};
